import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import GeneralStoreSelect from "components/DropDowns/GeneralStoreSelect";
import POSSelect from "components/DropDowns/POSSelect";

import { useTranslation } from "react-i18next";

function PaymentMethodPage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/payment-methods";
  const history = useHistory();
  const { id } = useParams();
  const [storeId, setStoreId] = useState(null);
  const [paymentMethodName, setPaymentMethodName] = useState("");
  const [paymentMethodDocName, setPaymentMethodDocName] = useState("");
  const [myDataCode, setMyDataCode] = useState(0);
  const [taxType, setTaxType] = useState(null);
  const [paymentMethodColor, setPaymentMethodColor] = useState("#ffffff");
  const [paymentMethodOrder, setPaymentMethodOrder] = useState(0);
  const [posId, setPosId] = useState(null);
  const [paymentMethodPreload, setPaymentMethodPreload] = useState(false);
  const [paymentMethodDeleted, setPaymentMethodDeleted] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleStoreId = (id) => {
    setStoreId(id);
  };

  const handlePosId = (id) => {
    setPosId(id);
  };

  const handleScroll = (e) => {
    e.target.blur();
  };

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/payment-methods/${id}`)
      .then((paymentMethod) => {
        fillFields(paymentMethod);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  }, []);

  const save = () => {
    setIsDisabled(true);
    const paymentMethod = {
      name: paymentMethodName,
      documentName: paymentMethodDocName,
      mydataCode: myDataCode,
      color: paymentMethodColor ? paymentMethodColor : "ffffff",
      order: paymentMethodOrder ? paymentMethodOrder : 0,
      taxType: taxType ? taxType : null,
      preload: paymentMethodPreload,
      posId: posId,
      storeId: storeId,
      deleted: paymentMethodDeleted,
    };

    if (id) {
      apiService
        .putJson(`api/v1/payment-methods/${id}`, paymentMethod)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.paymentMethodSavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/payment-methods", paymentMethod)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.paymentMethodCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (paymentMethod) => {
    setPaymentMethodName(paymentMethod.name);
    setPaymentMethodDocName(paymentMethod.documentName);
    setMyDataCode(paymentMethod.mydataCode);
    setPaymentMethodColor(paymentMethod.color);
    setPaymentMethodOrder(paymentMethod.order);
    setTaxType(paymentMethod.taxType);
    setPaymentMethodPreload(paymentMethod.preload);
    setPosId(paymentMethod.pos ? paymentMethod.pos.id : null);
    setPaymentMethodDeleted(paymentMethod.deleted);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editPaymentMethod") : t("pages.titles.createPaymentMethod")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.name")}</label>
                        <Form.Control
                          placeholder={t("common.labels.name")}
                          required={true}
                          type="text"
                          value={paymentMethodName}
                          onChange={(event) => setPaymentMethodName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.text")}</label>
                        <Form.Control
                          placeholder={t("common.labels.text")}
                          required={true}
                          type="text"
                          value={paymentMethodDocName}
                          onChange={(event) => setPaymentMethodDocName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.mydataCode")}</label>
                        <Form.Control
                          placeholder={t("common.labels.mydataCode")}
                          required={true}
                          type="number"
                          value={myDataCode}
                          onChange={(event) => setMyDataCode(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.color")}</label>
                        <Form.Control
                          placeholder={t("common.labels.color")}
                          required={true}
                          type="color"
                          value={paymentMethodColor}
                          onChange={(event) => setPaymentMethodColor(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.order")}</label>
                        <Form.Control
                          placeholder={t("common.labels.order")}
                          required={true}
                          type="number"
                          value={paymentMethodOrder}
                          onChange={(event) => setPaymentMethodOrder(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.taxType")}</label>
                        <Form.Control
                          placeholder={t("common.labels.taxType")}
                          required={true}
                          type="number"
                          value={taxType}
                          onChange={(event) => setTaxType(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <GeneralStoreSelect title={t("common.labels.store")} disabled={true} selectedStoreId={handleStoreId} />
                    </Col>
                    <Col>
                      <POSSelect title="POS" defaultValue={posId} handler={handlePosId} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="2">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-1"
                            checked={paymentMethodPreload}
                            onChange={(e) => setPaymentMethodPreload(e.target.checked)}
                          />
                          <span className="ml-1">{t("common.labels.preloadPos")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="2">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-2"
                            checked={paymentMethodDeleted}
                            onChange={(e) => setPaymentMethodDeleted(e.target.checked)}
                          />
                          <span className="ml-1">{t("common.labels.inactive")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PaymentMethodPage;
